// extracted by mini-css-extract-plugin
export default {"card":"PhotoCard_card__Eubtf"};